import { styled } from "goober";

export const NudgeTooltipContent = styled("div")`
  position: relative;
  width: 180px;
  font-weight: 450;
  line-height: 12px;

  &::before {
    content: "";
    position: absolute;
    top: -9px;
    right: 8px;
    width: 8px;
    height: 8px;
    background: var(--tooltip-bg);
    transform: rotate(45deg);
    clip-path: polygon(0 0, 100% 0, 0 100%);
  }

  &[data-align="left"]::before {
    left: 8px;
    right: auto;
  }
`;
